import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';

import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { GlobalConstants } from '../common/GlobalConstants ';

@Component({
  selector: 'app-mobile-contact',
  templateUrl: './mobile-contact.component.html',
  styleUrls: ['./mobile-contact.component.css']
})
export class MobileContactComponent extends BaseListCtl{

  constructor(public locator: ServiceLocatorService, private http: HttpClient, public route: ActivatedRoute) {
    super(locator.endpoints.MOBILECONTACT,locator,route);
  }

  excelData :any;
  downloadFile(): void {
    this.download()
      .subscribe(blob => saveAs(blob, 'ContactList.xlsx'));
  }

  download(): Observable<Blob> {
    let _self = this;
    let sid = localStorage.getItem( GlobalConstants.getKey('sessionId'));
    console.log(sid+'siddd' + this.form.searchParams);
    let url =  _self.locator.endpoints.MOBILECONTACT+"/exportContactList"+ ";jsessionid=" + sid;
    return this.http.post(url, this.form.searchParams, {
      responseType: 'blob'
    });

  }
  
  
  populateForm(form, data) {
    form.id = data.id;
    form.mobile=data.mobile;
    form.userId=data.userId;
    form.userName=data.userName;
    form.name=data.name
    form.email=data.email;
    form.mobileId=data.mobileId;
    
    console.log('----->',data);
  }
 


//    mobileContact() {

//     var _self = this;

//     _self.form.searchError = false;
//     _self.form.searchMessage = "";

//     console.log("Search Form", _self.form.searchParams);

//     let url = this.locator.endpoints.getEndpoint(this.locator.endpoints.PUBLIC, "/getContactList");
// console.log("url",url);
//     this.locator.http.post(url, this.form.data, function (res, error) {


//       if (error) {
//         return;
//       }

//       _self.form.searchError = !res.success;
//       _self.form.searchMessage = res.result.message;

//       if (res.success) {
//         _self.form.list = res.result.data;
//         _self.form.pageCount = res.result.pageCount;
//         _self.form.pageSize = res.result.pageSize;
//         _self.form.pageNoList = [];
//         //Build page number list
//         for (let i = 0; i < _self.form.pageCount; i++) {
//           _self.form.pageNoList.push(i);
//         }

//         //Check empty list
//         if (_self.form.list.length == 0) {
//           _self.form.message = "No record found";
//           _self.form.error = true;
//         }
//         console.log("List Size", _self.form.list.length);
//       }
//     });
  

  

// }
}